<template>
    <BaseDropdownMenu :sections="menuSections" side="left" :side-offset="4" @select="handleMenuSelect">
        <template #trigger>
            <BaseButton
                type="button"
                theme="neutral"
                size="sm"
                class="inline-flex items-center gap-2"
                :title="copiedInviteId === invite.id ? t('components.assessment.copied') : t('components.assessment.copyInviteLink')">
                <i class="bi" :class="copiedInviteId === invite.id ? 'bi-check2' : 'bi-clipboard'" aria-hidden="true"></i>
                {{ copiedInviteId === invite.id ? t("components.assessment.copiedShort") : t("components.assessment.copy") }}
            </BaseButton>
        </template>
    </BaseDropdownMenu>
</template>

<script setup lang="ts">
import type { CycleForSubject, InviteAnonymized } from "~vue/api/generated/reflections";
import BaseButton from "~vue/components/BaseButton.vue";
import BaseDropdownMenu, { type DropdownMenuItem, type DropdownMenuSection } from "~vue/components/BaseDropdownMenu.vue";
import { useInviteCopy } from "~vue/composables/useInviteCopy";
import { computed, toRef } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps<{
    invite: InviteAnonymized;
    cycle: CycleForSubject | null;
}>();

const { copiedInviteId, copyInviteLink, copyInviteMessage } = useInviteCopy(toRef(props, "cycle"));

const menuSections = computed<DropdownMenuSection[]>(() => [
    {
        id: "copy",
        items: [
            { id: "copy-link", type: "button", label: t("components.assessment.copyLink"), icon: "bi bi-link-45deg" },
            { id: "copy-message", type: "button", label: t("components.assessment.copyInviteMessage"), icon: "bi bi-chat-quote" },
        ],
    },
]);

const handleMenuSelect = (item: DropdownMenuItem) => {
    if (item.id === "copy-link") {
        copyInviteLink(props.invite);
    } else if (item.id === "copy-message") {
        copyInviteMessage(props.invite);
    }
};
</script>
